export class LocalStorage {
  constructor(private key: string) {}

  get<T>(opts?: { fallback: T }): T {
    const storage = getLocalStorage();
    const item = storage?.getItem(this.key) ?? "null";
    const parsedItem = JSON.parse(item);

    if (parsedItem?.__type === "Map") {
      return new Map(parsedItem.value) as T;
    }

    return parsedItem ?? opts?.fallback;
  }

  save<T>(value: T) {
    const storage = getLocalStorage();
    if (storage) {
      if (value instanceof Map) {
        this.saveMap(value);
      } else {
        const jsonStr = JSON.stringify(value);
        if (jsonStr === "{}") {
          this.saveMap(value);
        } else {
          storage.setItem(this.key, jsonStr);
        }
      }
    } else {
      console.warn("LocalStorage not available");
    }
  }

  private saveMap<T extends object>(value: T | any) {
    const storage = getLocalStorage()!;
    const serializedMap = {
      __type: "Map",
      value: Array.from(value.entries()),
    };
    storage.setItem(this.key, JSON.stringify(serializedMap));
  }
}

function getLocalStorage(): Storage | null {
  // NextJS SSR workaround
  // You can't disable SSR in next.config.js (on Next 13.5)
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
